import { NgForm, AbstractControl, UntypedFormGroup } from '@angular/forms';

export class WafFormHelper {
        static invalidateForm(ngForm: NgForm, formNativeElement: HTMLElement, focusOnFirstInvalidControl: boolean = true) {
            const invalidControls = collectInvalidControls(ngForm);
        invalidControls.forEach(c => c.markAsTouched());

        if (formNativeElement && focusOnFirstInvalidControl) {
                setTimeout(() => {
                    const firstInvalidElement = formNativeElement.getElementsByClassName('invalid')[0] as HTMLElement;
                if (firstInvalidElement) {
                        firstInvalidElement.focus();
                }
            }, 0);
        }
    }
}

function collectInvalidControls(ngForm: NgForm): AbstractControl[] {
    const stack: AbstractControl[] = [];

const controls: AbstractControl[] = [];

stack.push(...Object.keys(ngForm.controls).map(k => ngForm.controls[k]).filter(x => x.invalid));

while (stack.length > 0) {
        const control = stack.pop();

    if (control instanceof UntypedFormGroup) {
            stack.push(...Object.keys(control.controls).map(k => control.controls[k]).filter(y => y.invalid));
    }
    else {
            controls.push(control);
    }
}

return controls;
}